import { bscGetAbi, bscGetAbiFunctions, bscGetTxStatus, bscNftCreateCollection, bscNftMint, bscNftSmartContractVerify, bscTokenCreate, bscTokenSmartContractInteraction, bscTokenSmartContractVerify, bscTokenTransfer } from "./axiosRequests/axiosHandlerBsc";
import { Chain } from "./Chain";
import { TokenSmartContractInteraction } from "./models";
import { BscNftCreateCollection } from "./models/modelsBscNft/BscNftCreateCollection";
import { BscNftMint } from "./models/modelsBscNft/BscNftMint";
import { BscNftSmartContractVerify } from "./models/modelsBscNft/BscNftSmartContractVerify";
import { BscGetAbi } from "./models/modelsBscSmartContract/BscGetAbi";
import { BscGetAbiFunctions } from "./models/modelsBscSmartContract/BscGetAbiFunctions";
import { BscGetTxStatus } from "./models/modelsBscSmartContract/BscGetTxStatus";
import { BscTokenCreate } from "./models/modelsBscToken/BscTokenCreate";
import { BscTokenSmartContractVerify } from "./models/modelsBscToken/BscTokenSmartContractVerify";
import { BscTokenTransfer } from "./models/modelsBscToken/BscTokenTransfer";

export class Bsc extends Chain { 

    public bscIssueToken = async (
        payload: BscTokenCreate
    ): Promise<any> => {
        return await bscTokenCreate(payload, this.initialize);
    }

    public bscTransferToken = async (
        payload: BscTokenTransfer
    ): Promise<any> => {
        return await bscTokenTransfer(payload,  this.initialize);
    }

    public bscNftCreateCollection = async (
        payload: BscNftCreateCollection
    ): Promise<any> => {
        return await bscNftCreateCollection(payload, this.initialize);
    }

    public bscMintNft = async (
        payload: BscNftMint
    ): Promise<any> => {
        return await bscNftMint(payload, this.initialize);
    }

    public bscVerifySmartContractNft = async (
        payload: BscNftSmartContractVerify
    ): Promise<any> => {
        return await bscNftSmartContractVerify(payload, this.initialize);
    }

    public bscVerifySmartContractToken = async (
        payload: BscTokenSmartContractVerify
    ): Promise<any> => {
        return await bscTokenSmartContractVerify(payload, this.initialize);
    }

    public bscAbi = async (
        payload: BscGetAbi
    ): Promise<any> => {
        return await bscGetAbi(payload,  this.initialize);
    }

    public bscAbiFunctions = async (
        payload: BscGetAbiFunctions
    ): Promise<any> => {
        return await bscGetAbiFunctions(payload,  this.initialize);
    }

    public bscTxStatus = async (
        payload: BscGetTxStatus
    ): Promise<any> => {
        return await bscGetTxStatus(payload,  this.initialize);
    }
    // public establishConnection = async (networkProvider: any): Promise<any> => {
    //     // "https://data-seed-prebsc-1-s1.binance.org:8545"
    //     return new Web3(new Web3.providers.HttpProvider(networkProvider))
    // }

    // public signTransaction = async (
    //     rawTransaction: any,
    //     web3: any,
    //     privateKey: any
    // ): Promise<any> => {
    //     const decryptedAccount = web3.eth.accounts.privateKeyToAccount(
    //         privateKey
    //     )
    //     return await decryptedAccount.signTransaction(rawTransaction)
    // }

    // public sendTransaction = async (signedTx: any, web3: any): Promise<any> => {
    //     await web3.eth
    //         .sendSignedTransaction(signedTx.rawTransaction)
    //         .then((receipt: any) =>
    //             console.log('Transaction receipt: ', receipt)
    //         )
    // }
    public bscTokenContractInteract = async (payload: TokenSmartContractInteraction): Promise<any> => {
       return await bscTokenSmartContractInteraction (payload, this.initialize);
    }
}
